import { Loader } from 'lucide-react';
import React from 'react';
import { cn } from '../../utils';
import Column from './Containers/Column';
import { SubtitleText } from './Typography/PageHeader';
import { useTranslation } from 'react-i18next';

type LoadingIconSize = 'small' | 'medium' | 'large';

const LoadingIcon = ({
  size = 'small',
  className,
}: {
  size?: LoadingIconSize;
  className?: string;
}) => {
  return (
    <Loader
      className={cn(
        'animate-spin ',
        size === 'small' && 'h-5 w-5',
        size === 'medium' && 'h-6 w-6',
        size === 'large' && 'h-8 w-8',
        className
      )}
    />
  );
};

export default LoadingIcon;

export const PageViewLoading = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <Column
      className={cn(
        'items-center justify-center h-full min-h-[75vh] gap-4',
        className
      )}
    >
      <LoadingIcon size="medium" />
      <SubtitleText
        className="text-secondary font-semibold"
        subtitle={t('common.wait_moment')}
      />
    </Column>
  );
};
